import { SearchParameterTypeEnum } from '@lib/enums/search.enum'
import { SearchParameter } from 'types/search.type'

export const setCurrentUserParam = (
  parameter: SearchParameter,
  valueKey: any,
  selected: boolean,
  get: any,
  set: any
) => {
  const key = Object.keys(parameter)[0]
  const currentParams = get().currentUserSearchParameters
  const existingIndex = currentParams.findIndex(
    (p) => Object.keys(p)[0] === key
  )
  const paramDef = parameter[key]

  const foundValue = paramDef.values.find((v) => v.key === valueKey)
  if (!foundValue) return

  if (paramDef.type === SearchParameterTypeEnum.SWITCH) {
    const newEntry = {
      [key]: {
        ...paramDef,
        values: selected ? [{ ...foundValue, selected: true }] : [],
      },
    }

    const updatedParams = [...currentParams]
    if (existingIndex !== -1) updatedParams[existingIndex] = newEntry
    else updatedParams.push(newEntry)
    set({ currentUserSearchParameters: updatedParams })
    return
  }

  const existingValues =
    existingIndex !== -1 ? currentParams[existingIndex][key].values : []

  const newValues = selected
    ? [...existingValues, { ...foundValue, selected: selected }]
    : existingValues.filter((v) => v.key !== valueKey)

  const newEntry = {
    [key]: {
      ...paramDef,
      values: newValues,
    },
  }

  const updatedParams = [...currentParams]
  if (existingIndex !== -1) {
    if (newValues.length === 0) updatedParams.splice(existingIndex, 1)
    else updatedParams[existingIndex] = newEntry
  } else updatedParams.push(newEntry)

  set({ currentUserSearchParameters: updatedParams })
}
